<template>
    <div class="panel">
    <div v-html="content"></div>
    </div>
</template>

<script>
    import Markdown_it from 'markdown-it'
    import axios from "axios"
    export default{
        name:"Service",
        data(){
            return{
                content:""
            }
        },
        created:function(){
            let lan = "zh";
            if(this.$route.query){
                lan = this.$route.query["lan"];
            }
            if(lan == null || lan == "undefined"){
                lan = this.getCookieByName("lan");
            }
            let url = "";
            if(lan == "zh" || lan == null){
                url = "/static/service-zh.md";
            }else{
                url = "/static/service-en.md";
            }
            document.title = this.$t("message.service_protocol_name");
            var that = this;
            axios.get(url)
            .then(function(res){
                let md = new Markdown_it();
                that.content = md.render(res.data);
            })
            .catch(function(error){
            })
        }
    }
</script>

<style scoped>

    html{
        font-size: 12px;
    }

    .panel{
        padding: 20px;
        box-sizing: border-box;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Service.vue